import * as RadixTooltip from '@radix-ui/react-tooltip';
import type { ReactElement, ReactNode } from 'react';

export function TooltipProvider({ children }: { children: ReactNode }) {
  return <RadixTooltip.Provider delayDuration={300} skipDelayDuration={100}>{children}</RadixTooltip.Provider>;
}

export function Tooltip({ content, side = 'top', delayDuration, children }: {
  content: ReactNode; side?: 'top' | 'right' | 'bottom' | 'left'; delayDuration?: number; children: ReactElement;
}) {
  // Self-contained provider so Tooltip works standalone (e.g. in tests) even without a
  // TooltipProvider mounted at the app root; nesting an app-level provider still works fine.
  return <RadixTooltip.Provider delayDuration={300}>
    <RadixTooltip.Root {...(delayDuration === undefined ? {} : { delayDuration })}>
      <RadixTooltip.Trigger asChild>{children}</RadixTooltip.Trigger>
      <RadixTooltip.Portal>
        <RadixTooltip.Content className="bv-tooltip" side={side} sideOffset={6}>
          {content}<RadixTooltip.Arrow className="bv-tooltip__arrow" />
        </RadixTooltip.Content>
      </RadixTooltip.Portal>
    </RadixTooltip.Root>
  </RadixTooltip.Provider>;
}
